export const KEYBOARD_KEYCODE_CONSTANTS = Object.freeze({
  ESCAPE_KEY: 27,
});
